import React from 'react';
import ContactSection from '../components/ContactSection';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-gray-100 pt-8">
      <ContactSection />
    </div>
  );
}
